import { useNavigate } from "react-router-dom";
import { useClutch } from "./ClutchContext";

const GetStarted = () => {
  const navigate = useNavigate();
  const { config } = useClutch();

  return (
    <div className="cl-root">
      <div className="cl-bg" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/stadium-bg.png)` }} />
      <div className="cl-wrap cl-hero-wrap cl-scroll">
        <div className="cl-spacer" />
        <div className="cl-hero-grid">
          <div className="cl-hero-copy">
            <div className="cl-logo" style={{ marginBottom: 10 }}>
              <b>{config.brand.name.replace(/Plix$/, "")}</b><span>Plix</span><sup>✛</sup>
            </div>
            <div className="cl-presents" style={{ marginBottom: 14 }}>presents</div>
            <div className="cl-kicker">FIFA WORLD CUP&nbsp;&nbsp;|&nbsp;&nbsp;PRESSURE CAM</div>
            <h1 className="cl-title" style={{ marginTop: 12 }}>Keep your<br />cool from<br />the spot.</h1>
            <p className="cl-sub" style={{ marginTop: 18 }}>
              Five-a-side nerves, sudden-death pressure. We read your real pulse from your face while you
              take the kicks — then score your composure.
            </p>
          </div>
          <img className="cl-hero-mascot" src={`${process.env.PUBLIC_URL}/mascot-hero.png`} alt="CarePlix mascot" />
        </div>

        <div className="cl-spacer" />
        <button className="cl-btn" onClick={() => navigate("/details")}>Get Started</button>
        <p className="cl-foot" style={{ marginTop: 12 }}>Powered by CarePlix Vitals</p>
      </div>
    </div>
  );
};

export default GetStarted;
